import AdvtFullSize from './components/AdvtFullSize/AdvtFullSize';
import { useGetParams } from './hooks/useGetParams';
import { useVote } from './hooks/useVote';
import { useBroadcast } from './hooks/useBroadcast';
import { useMemo } from 'react';
// import defaultBackground from './assets/images/bg.png';
import Question from './components/Question/Question';
import { AnimatePresence, motion } from 'framer-motion';
import Winners from './components/Winners/Winners';

import posterDefault from './assets/images/bgPoster.webp';
import bgDefaultVideo from './assets/video/bgVideo.webm';
import { Correct } from './components/Correct/Correct';

import confetti from './assets/images/confetti-29.gif';
import logo from './assets/images/logo.png';

function App() {
  const { voteState, currentState, isVisible } = useVote();
  const { winnerMessages, messages } = useBroadcast();

  const {
    bg,
    phoneNumber,
    socials,
    title,
    qrCode,
    questionFontSize,
    winnerFontSize,
    bgVideo,
    bgPoster,
  } = useGetParams();

  const advt_info = useMemo(
    () => ({
      qrCode: qrCode,
      label: title,
      number: phoneNumber,
      socials: socials?.split(','),
    }),
    [phoneNumber, socials, title, qrCode],
  );

  const correctVar = voteState?.vars && voteState.vars.find((v) => v.correct);

  return (
    <div className="app-wrapper">
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            style={{ height: '100%' }}
            key="S1"
            initial={{ y: 0 }}
            exit={{ y: '-100vh' }}
            transition={{ duration: 0.33 }}
          >
            <Question
              title={voteState?.title}
              questionFontSize={questionFontSize}
            />
          </motion.div>
        )}
        {currentState === 'S2' && (
          <motion.div
            key="S2"
            style={{ height: '100%' }}
            initial={{ y: 0 }}
            exit={{ y: '-100vh' }}
            transition={{ duration: 0.4 }}
          >
            <AdvtFullSize advtInfo={advt_info} messages={messages} />
          </motion.div>
        )}

        {currentState === 'S3' && (
          <motion.div
            key="S3"
            style={{ height: '100%' }}
            initial={{ x: '100vw' }}
            animate={{ x: 0 }}
            exit={{ x: '-100vw' }}
            transition={{ duration: 0.4 }}
          >
            <Correct correctVar={correctVar} />
          </motion.div>
        )}

        {currentState === 'S4' && (
          <motion.div
            key="S4"
            style={{ height: '100%' }}
            initial={{ y: 0 }}
            exit={{ y: '-100vh' }}
            transition={{ duration: 0.4 }}
          >
            <Winners
              winnerFontSize={winnerFontSize}
              winnerMessages={winnerMessages}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <video
        autoPlay="autoplay"
        playsInline
        muted="muted"
        loop
        id="bgVideo"
        poster={bgVideo === '1' ? posterDefault : bgPoster}
      >
        <source
          src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
          type="video/webm"
        ></source>
      </video>

      <div id="img-loader" />

      {/* preload */}
      <img src={confetti} alt="confetti" style={{ display: 'none' }} />
      <img src={logo} alt="logo" style={{ display: 'none' }} />
      <img
        src={correctVar?.varImgUrl}
        alt="correctVar"
        style={{ display: 'none' }}
      />
    </div>
  );
}

export default App;
